export const MAX_DURATION = 15; // s
export const MIN_DURATION = 1; // s
export const MAX_LOOP_QUANTITY = 180;
export const CREDIT_CONSUME = 5;
export const IMG_MAX_DEMENSION = 768;
export const VIDEO_MAX_DEMENSION = 512;
export const LOGIN_SCENE = "022";
export const PROJECT_TYPE = "mimic";
export const POSITION = "mimic";
export const ZOOM_SPEED = 0.05;
export const MIN_ZOOM = 1;
export const MAX_ZOOM = 10;
export const COMMUNITY_EXP_TEMP_TITLE_PREFFIX = "community_exp_temp_";
export const CUS_EXP_TEMP_TITLE_PREFFIX = "cus_exp_temp_";

export enum ExpTempType {
  Community,
  Preset,
  Cus,
}

export enum APICode {
  Success = "000",
  NotLogin = "114",
  ParamsError = "101",
}

export enum FaceDetectRes {
  NoFace,
  TooManyFace,
  Success,
  TooSmall,
  TooBig,
  Unknown,
}

export enum TaskStatus {
  Generating = 0,
  Success = 1,
  Failed = 2,
}

export const I18nLangMap: any = {
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  id: 'id_ID',
  jp: 'ja_JP',
  pt: 'pt_BR',
  ru: 'ru_RU',
  cn: 'zh_CN',
  tw: 'zh_TW',
};

export const LocalStorageKey = {
  deviceId : "fotor_device_id",
  removeTipShowTimes: "fotor_ai_baby_remove_tip_show_times",
  userInfo: "fotor_common_user_Info",
}

export enum CollectStatus {
  UnCollect = 0,
  Collected = 1,
}